import { DatePicker } from './date-picker'

type EventDateRangePickerProps = {
  startDate: string
  endDate: string
  min?: string
  onStartDateChange: (value: string) => void
  onEndDateChange: (value: string) => void
  error?: string
}

export function EventDateRangePicker({
  startDate,
  endDate,
  min,
  onStartDateChange,
  onEndDateChange,
  error,
}: EventDateRangePickerProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <div className="flex-1">
          <DatePicker
            value={startDate}
            onChange={onStartDateChange}
            minDate={min}
            placeholder="Start date"
            ariaLabel="Start date"
          />
        </div>
        <div className="flex-1">
          <DatePicker
            value={endDate}
            onChange={onEndDateChange}
            minDate={min}
            placeholder="End date"
            ariaLabel="End date"
          />
        </div>
      </div>
      {error ? <p className="text-sm text-destructive">{error}</p> : null}
    </div>
  )
}
